import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { WarrantyItem } from '@/services/reparoly/paymentApi';

export type WarrantiesState = {
  items: WarrantyItem[];
  lastFetchedAt: string | null;
};

const initialState: WarrantiesState = {
  items: [],
  lastFetchedAt: null,
};

const warrantiesSlice = createSlice({
  name: 'warranties',
  initialState,
  reducers: {
    setWarranties(state, action: PayloadAction<{ items: WarrantyItem[]; fetchedAt?: string }>) {
      state.items = action.payload.items || [];
      state.lastFetchedAt = action.payload.fetchedAt || new Date().toISOString();
    },
    resetWarranties: () => initialState,
  },
});

export const { setWarranties, resetWarranties } = warrantiesSlice.actions;
export default warrantiesSlice.reducer;
